import React from "react";
import { Row, Col } from "react-bootstrap";

import Testimonials from "./Testimonials";
import reviews from "./data";
import useInViewOnce from "../../hooks/useInViewOnce";
import { useTranslation } from "react-i18next";

function Testimonial2() {
  const { t } = useTranslation();
  const videoId = "5mPU-mIQgoQ";

  const { ref: voicesRef, hasEntered: voicesSeen } = useInViewOnce({
    threshold: 0.18,
    once: true,
  });

  const { ref: videoRef, hasEntered: videoSeen } = useInViewOnce({
    threshold: 0.18,
    once: true,
  });

  return (
    <>
      <section
        ref={voicesRef}
        className={`testimonials-section testimonials-reveal${voicesSeen ? " is-seen" : ""}`}
        aria-label={t("testimonialsPage.a11y.carousel")}
      >
        <h2 className="testimonials-section-heading">{t("testimonialsPage.voices.title")}</h2>
        <p className="testimonials-section-lead">{t("testimonialsPage.voices.lead")}</p>

        <div className="testimonials-center">
          <Testimonials reviews={reviews} />
        </div>
      </section>

      <section
        ref={videoRef}
        className={`testimonials-section testimonials-reveal${videoSeen ? " is-seen" : ""}`}
        aria-label={t("testimonialsPage.a11y.video")}
      >
        <Row style={{ justifyContent: "center" }}>
          <Col md={12}>
            <h2 className="testimonials-section-heading">{t("testimonialsPage.video.title")}</h2>
            <div className="policy-card testimonials-video-card">
              <div className="testimonials-video">
                <iframe
                  title={t("testimonialsPage.video.iframeTitle")}
                  src={`https://www.youtube.com/embed/${videoId}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>
          </Col>
        </Row>
      </section>
    </>
  );
}

export default Testimonial2;
